import { useState, useEffect } from 'react';
import { ScreenSize, ScreenSizeFloor } from '../../styles/screen-sizes';
import { useDispatch } from 'react-redux';
import Presentation from '../../logic/redux/presentation';

const getScreenSize = (): ScreenSize => {
  const windowWidth = window.innerWidth;

  if (windowWidth < ScreenSizeFloor.SM) {
    return ScreenSize.XS;
  } else if (windowWidth < ScreenSizeFloor.MD) {
    return ScreenSize.SM;
  } else if (windowWidth < ScreenSizeFloor.LG) {
    return ScreenSize.MD;
  } else if (windowWidth < ScreenSizeFloor.XL) {
    return ScreenSize.LG;
  } else {
    return ScreenSize.XL;
  }
};

const useScreenWidthObserver = (): void => {
  const dispatch = useDispatch();

  const mediaSMBoundaryMinQuery = useState(
    window.matchMedia(`(min-width: ${ScreenSizeFloor.SM}px)`),
  )[0];

  const mediaMDBoundaryMinQuery = useState(
    window.matchMedia(`(min-width: ${ScreenSizeFloor.MD}px)`),
  )[0];

  const mediaLGBoundaryMinQuery = useState(
    window.matchMedia(`(min-width: ${ScreenSizeFloor.LG}px)`),
  )[0];

  const mediaXLBoundaryMinQuery = useState(
    window.matchMedia(`(min-width: ${ScreenSizeFloor.XL}px)`),
  )[0];

  useEffect(() => {
    dispatch(Presentation.actions.setScreenSize(getScreenSize()));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const mediaQueryChanged = (): void => {
    dispatch(Presentation.actions.setScreenSize(getScreenSize()));
  };

  useEffect(() => {
    mediaSMBoundaryMinQuery?.addListener(mediaQueryChanged);
    mediaMDBoundaryMinQuery?.addListener(mediaQueryChanged);
    mediaLGBoundaryMinQuery?.addListener(mediaQueryChanged);
    mediaXLBoundaryMinQuery?.addListener(mediaQueryChanged);
    return () => {
      mediaSMBoundaryMinQuery?.removeListener(mediaQueryChanged);
      mediaMDBoundaryMinQuery?.removeListener(mediaQueryChanged);
      mediaLGBoundaryMinQuery?.removeListener(mediaQueryChanged);
      mediaXLBoundaryMinQuery?.removeListener(mediaQueryChanged);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

const ScreenWidthObserver = (): null => {
  useScreenWidthObserver();
  return null;
};

export default ScreenWidthObserver;
